export default __webpack_public_path__ + "static/media/Rambla-BoldItalic.60aa74fe.ttf";